import { createContext, useContext, useMemo, useState, useEffect, useRef } from "react";
import { useSettings } from "@/context/SettingsContext";

const DateFilterContext = createContext(null);

function computeRange(key, custom) {
  const now = new Date();
  const end = new Date(now.getTime() + 24 * 3600 * 1000).toISOString();
  const q = Math.floor(now.getMonth() / 3);
  let start = null;
  if (key === "today") {
    const d = new Date(now); d.setHours(0, 0, 0, 0); start = d.toISOString();
  } else if (key === "month") {
    start = new Date(now.getFullYear(), now.getMonth(), 1).toISOString();
  } else if (key === "quarter") {
    start = new Date(now.getFullYear(), q * 3, 1).toISOString();
  } else if (key === "last_quarter") {
    const lq = q - 1;
    const y = lq < 0 ? now.getFullYear() - 1 : now.getFullYear();
    const m = ((lq % 4) + 4) % 4;
    return { start: new Date(y, m * 3, 1).toISOString(), end: new Date(now.getFullYear(), q * 3, 1).toISOString() };
  } else if (key === "ytd") {
    start = new Date(now.getFullYear(), 0, 1).toISOString();
  } else if (key === "custom" && custom?.start) {
    return { start: new Date(custom.start).toISOString(), end: custom.end ? new Date(custom.end).toISOString() : end };
  } else {
    return { start: null, end: null }; // all
  }
  return { start, end };
}

export function DateFilterProvider({ children }) {
  const { settings, loaded } = useSettings();
  const [rangeKey, setRangeKey] = useState("all");
  const [custom, setCustom] = useState({ start: "", end: "" });
  const applied = useRef(false);
  useEffect(() => {
    if (!applied.current && loaded && settings?.default_date_range) {
      applied.current = true;
      setRangeKey(settings.default_date_range);
    }
  }, [loaded, settings]);
  const { start, end } = useMemo(() => computeRange(rangeKey, custom), [rangeKey, custom]);
  return (
    <DateFilterContext.Provider value={{ rangeKey, setRangeKey, custom, setCustom, start, end }}>
      {children}
    </DateFilterContext.Provider>
  );
}

export const useDateFilter = () => useContext(DateFilterContext);
